import type { ChatRequest } from "@/features/chat/types";

/**
 * Where GAIA's replies come from.
 *
 * The real implementation posts to a `gaia_worker` on the fleet, which wraps the agent in
 * `packages/ilagent` - identity injected server-side, authorization in the tools. That worker does
 * not exist yet, so this is mocked; the screens depend only on this interface.
 */
export interface GaiaRepository {
  sendMessage(request: ChatRequest): Promise<string>;
}

/** Long enough that the "thinking" state is visible while developing, short enough not to annoy. */
const MOCK_DELAY_MS = 400;

const mockGaiaRepository: GaiaRepository = {
  sendMessage: ({ message }) =>
    new Promise((resolve) => {
      setTimeout(
        () =>
          resolve(
            `GAIA is not connected yet - this is a stand-in reply so the chat screen can be ` +
              `built and reviewed. You asked: “${message}”`,
          ),
        MOCK_DELAY_MS,
      );
    }),
};

export const gaiaRepository: GaiaRepository = mockGaiaRepository;
